import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const Search = () => {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.target.form.dispatchEvent(new Event("submit"));

      if (value) {
        navigate(`/search?keywords=${value}`, { replace: true });
        setValue("");
      }
    }
  };

  return (
    <form>
      <label>
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className="border-2 border-green-600 w-full h-12 px-5 rounded-3xl focus:outline-none bg-gray-50 md:w-80 md:ml-5"
          placeholder="Search on title or author..."
        />
      </label>
    </form>
  );
};
